"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = exports.mapStateToProps = void 0;
var React = require("react");
var moment = require("moment");
var react_redux_1 = require("react-redux");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var diaryEntriesActions = require("@caddigital/sok-reducers/lib/actions/diaryentries/current");
var diaryEntriesListActions = require("@caddigital/sok-reducers/lib/actions/diaryentries/list");
var printEntriesListActions = require("@caddigital/sok-reducers/lib/actions/diaryentries/print");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
require("./printEntriesModalStyles.scss");
var DatePicker_1 = require("components/DatePicker");
var types_1 = require("types");
var mapStateToProps = function (state) {
    return {
        diaryEntries: state.diaryentries.list,
        createdEntryUuid: state.diaryentries.current.createdEntryUuid,
        currentWorksiteDiary: state.sokosite.current.worksiteDiary,
        printEntries: state.diaryentries.print,
        selected: state.diaryentries.list.selected
    };
};
exports.mapStateToProps = mapStateToProps;
var mapDispatchToProps = function (dispatch) { return ({
    fetchDiaryEntriesToPrint: function (diaryUuid, from, to) {
        return dispatch(printEntriesListActions.fetchRequest(diaryUuid, from, to));
    },
    clearDiaryEntriesToPrint: function () {
        return dispatch(printEntriesListActions.clearRequest());
    },
    clearState: function () { return dispatch(diaryEntriesActions.clear()); },
    toggleSelection: function (diaryUuid) {
        return dispatch(diaryEntriesListActions.toggleSelection(diaryUuid));
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
var statePropsExtractable = (0, types_1.extractReturnType)(exports.mapStateToProps);
var dispatchPropsExtractable = (0, types_1.extractReturnType)(exports.mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(exports.mapStateToProps, exports.mapDispatchToProps), react_router_dom_1.withRouter, (0, recompose_1.lifecycle)({
    shouldComponentUpdate: function (nextProps) {
        if (this.props.createdEntryUuid !== nextProps.createdEntryUuid) {
            this.props.clearState();
        }
        return true;
    }
}), recompose_1.pure);
exports.default = enhance(function (props) {
    var _a = React.useState(), pdfContent = _a[0], setPdfContent = _a[1];
    var _b = React.useState('output.pdf'), pdfFileName = _b[0], setPdfFileName = _b[1];
    // Resets printEntries.list and toggled selections on page load
    React.useEffect(function () {
        props.clearDiaryEntriesToPrint();
        props.selected.forEach(function (entry) { return props.toggleSelection(entry); });
    }, []);
    // If endDate becomes older than startDate, make them the same date
    React.useEffect(function () {
        if (props.startDate && props.endDate) {
            if (props.endDate < props.startDate)
                props.setEndDate(props.startDate);
        }
    }, [props.startDate]);
    var getMinMaxEntries = function () {
        var entries = props.diaryEntries.list.map(function (entry) {
            var date = entry.diary_date.toString();
            return parseInt(date, 10);
        });
        var earliestEntry = Math.min.apply(Math, entries);
        var lastEntry = Math.max.apply(Math, entries);
        if (props.diaryEntries.selected.length > 0 &&
            props.startDate &&
            props.endDate) {
            earliestEntry = props.startDate.getTime();
            lastEntry = props.endDate.getTime();
        }
        return { firstEntry: earliestEntry, lastEntry: lastEntry };
    };
    // Gets all entries between the start and end dates from the database
    var fetchEntriesToPrint = function () {
        if (props.currentWorksiteDiary && props.startDate && props.endDate) {
            props.fetchDiaryEntriesToPrint(props.currentWorksiteDiary.diary_uuid, moment(props.startDate).format('YYYY-MM-DD').toString(), moment(props.endDate).format('YYYY-MM-DD').toString());
        }
    };
    // Helper to calculate eg. equipment total
    var countStatusValuesTogether = function (statuses) {
        var total = 0;
        statuses.map(function (x) {
            total += x.count;
        });
        return total;
    };
    // Executes the PDF printing
    var pdfRef = (0, react_1.useRef)(null);
    var startDownload = function () {
        var el = pdfRef.current;
        if (el !== null) {
            el.style.display = 'block';
            var newWindow = window.open('');
            if (newWindow !== null) {
                var headElement = newWindow.document.createElement('head');
                var linkElement = newWindow.document.createElement('link');
                linkElement.rel = 'stylesheet';
                linkElement.href =
                    'https://fonts.googleapis.com/css2?family=Roboto&display=swap';
                headElement.appendChild(linkElement);
                newWindow.document.body.appendChild(el);
                newWindow.document.title = pdfFileName;
                newWindow.focus();
                newWindow.print();
                newWindow.close();
            }
        }
        props.selected.forEach(function (entry) { return props.toggleSelection(entry); });
        props.clearState();
    };
    // Once the range of entries to print have been fetched, this hook
    // listens for the props.printEntries.list changes and appends the appropriate
    // data to the tables for each of the entries in range.
    React.useEffect(function () {
        var pdfTempFileName = "".concat(props.currentWorksiteDiary && "".concat(props.currentWorksiteDiary.name, "_")).concat(props.currentWorksiteDiary && props.currentWorksiteDiary.site_number
            ? "".concat(props.currentWorksiteDiary.site_number, "_")
            : '').concat((0, translation_1.getLocalization)('diaryEntriesView/entries').toLowerCase(), "_").concat(moment(props.startDate)
            .format('YYYY-MM-DD')
            .toString(), "-").concat(moment(props.endDate).format('YYYY-MM-DD').toString(), ".pdf");
        var pdf = props.printEntries.list.map(function (entry) {
            var startedJobs = entry.jobs
                ? entry.jobs.filter(function (x) { return x.new_revision.status === 'STARTED'; })
                : [];
            var ongoingJobs = entry.jobs
                ? entry.jobs.filter(function (x) { return x.new_revision.status === 'IN_PROGRESS'; })
                : [];
            var readyJobs = entry.jobs
                ? entry.jobs.filter(function (x) { return x.new_revision.status === 'DONE'; })
                : [];
            var onholdJobs = entry.jobs
                ? entry.jobs.filter(function (x) { return x.new_revision.status === 'ON_HOLD'; })
                : [];
            return (React.createElement("div", { id: "pdf-content-container-".concat(entry.entry_uuid), style: {
                    pageBreakAfter: 'always',
                    fontFamily: '"Roboto", sans-serif',
                    fontSize: '12px'
                } },
                React.createElement("table", { style: {
                        width: '100%',
                        textAlign: 'left',
                        borderBottom: '2px solid black'
                    }, id: "printentries-table-info-".concat(entry.entry_uuid) },
                    React.createElement("tr", null,
                        React.createElement("td", { colSpan: 2 },
                            React.createElement("span", { style: { fontWeight: 600 } }, "".concat((0, translation_1.getLocalization)('diaryEntriesView/printEntries/worksite'), ": ")),
                            React.createElement("span", null, "".concat(props.currentWorksiteDiary &&
                                "".concat(props.currentWorksiteDiary.name, " / "), " ").concat(props.currentWorksiteDiary &&
                                props.currentWorksiteDiary.site_number
                                ? props.currentWorksiteDiary.site_number
                                : '')))),
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement("span", { style: { fontWeight: 600 } }, "".concat((0, translation_1.getLocalization)('diaryEntriesView/printEntries/date'), ": ")),
                            React.createElement("span", null, "".concat(moment(entry.diary_date).format('L')))),
                        React.createElement("td", null,
                            React.createElement("span", { style: { fontWeight: 600 } }, "".concat((0, translation_1.getLocalization)('diaryEntriesView/printEntries/year_week'), ": ")),
                            React.createElement("span", null, "".concat(moment(entry.diary_date).format('YYYY[/]W')))))),
                React.createElement("table", { id: "printentries-table-weather-".concat(entry.entry_uuid), style: {
                        width: '100%',
                        textAlign: 'left',
                        borderBottom: '2px solid black'
                    } },
                    React.createElement("tr", null,
                        React.createElement("th", { style: { fontSize: '15px', fontWeight: 600 } }, (0, translation_1.getLocalization)('diaryEntriesView/printEntries/weather'))),
                    entry.weather_info ? (React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", null, "7.00 ".concat((0, translation_1.getLocalization)('diaryEntriesView/printEntries/temperature'), ": ").concat(entry.weather_info.tempAt7 !== undefined
                                ? entry.weather_info.tempAt7
                                : '-')),
                            React.createElement("td", null, "".concat((0, translation_1.getLocalization)('diaryEntriesView/printEntries/condition'), ": ").concat(entry.weather_info.conditionAt7 !== undefined
                                ? (0, translation_1.getLocalization)("diaryEntriesView/printEntries/weathercondition/".concat(entry.weather_info.conditionAt7))
                                : '-'))),
                        React.createElement("tr", null,
                            React.createElement("td", null, "12.00 ".concat((0, translation_1.getLocalization)('diaryEntriesView/printEntries/temperature'), ": ").concat(entry.weather_info.tempAt12 !== undefined
                                ? entry.weather_info.tempAt12
                                : '-')),
                            React.createElement("td", null, "".concat((0, translation_1.getLocalization)('diaryEntriesView/printEntries/condition'), ": ").concat(entry.weather_info.conditionAt12 !== undefined
                                ? (0, translation_1.getLocalization)("diaryEntriesView/printEntries/weathercondition/".concat(entry.weather_info.conditionAt12))
                                : '-'))))) : (React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", null, "-"))))),
                React.createElement("table", { id: "printentries-table-employee-status-".concat(entry.entry_uuid), style: {
                        width: '100%',
                        textAlign: 'left',
                        borderBottom: '2px solid black'
                    } },
                    React.createElement("tr", null,
                        React.createElement("th", { style: { fontSize: '15px', fontWeight: 600 } }, (0, translation_1.getLocalization)('diaryEntriesView/printEntries/employeeStatus'))),
                    entry.employee_status && entry.employee_status.length !== 0 ? (entry.employee_status.map(function (status) { return (React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", null,
                                React.createElement("table", { style: {
                                        width: '100%',
                                        borderBottom: '1px solid black'
                                    } },
                                    React.createElement("tr", null,
                                        React.createElement("td", null,
                                            status.name,
                                            ":"),
                                        React.createElement("td", { style: { textAlign: 'right' } }, status.count))))))); })) : (React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", null, "-")))),
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", { style: { textAlign: 'right' } },
                                (0, translation_1.getLocalization)('diaryEntriesView/printEntries/total'),
                                ":",
                                ' ',
                                entry.employee_status && entry.employee_status.length !== 0
                                    ? countStatusValuesTogether(entry.employee_status)
                                    : '')))),
                React.createElement("table", { id: "printentries-table-equipment-status-".concat(entry.entry_uuid), style: {
                        width: '100%',
                        textAlign: 'left',
                        borderBottom: '2px solid black'
                    } },
                    React.createElement("tr", null,
                        React.createElement("th", { style: { fontSize: '15px', fontWeight: 600 } },
                            (0, translation_1.getLocalization)('diaryEntriesView/printEntries/equipmentStatus'),
                            ":")),
                    entry.equipment_status && entry.equipment_status.length !== 0 ? (entry.equipment_status.map(function (status) { return (React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", null,
                                React.createElement("table", { style: {
                                        width: '100%',
                                        borderBottom: '1px solid black'
                                    } },
                                    React.createElement("tr", null,
                                        React.createElement("td", null,
                                            status.name,
                                            ":"),
                                        React.createElement("td", { style: { textAlign: 'right' } }, status.count))))))); })) : (React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", null, "-")))),
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", { style: { textAlign: 'right' } },
                                (0, translation_1.getLocalization)('diaryEntriesView/printEntries/total'),
                                ":",
                                ' ',
                                entry.equipment_status && entry.equipment_status.length !== 0
                                    ? countStatusValuesTogether(entry.equipment_status)
                                    : '')))),
                React.createElement("table", { id: "printentries-table-job-statuses-".concat(entry.entry_uuid), style: {
                        width: '100%',
                        textAlign: 'left',
                        borderBottom: '2px solid black'
                    } },
                    React.createElement("tr", null,
                        React.createElement("th", { style: { fontSize: '15px', fontWeight: 600 } }, (0, translation_1.getLocalization)('diaryEntriesView/printEntries/jobStatuses'))),
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement("table", { style: {
                                    width: '100%',
                                    marginLeft: '1rem',
                                    borderBottom: '1px solid black'
                                } },
                                React.createElement("tr", null,
                                    React.createElement("td", null,
                                        React.createElement("span", { style: { fontWeight: 600, fontSize: '13px' } }, (0, translation_1.getLocalization)('diaryEntriesView/printEntries/startedJobs'))))))),
                    startedJobs.map(function (job) { return (React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement("table", { style: {
                                    width: '100%',
                                    marginLeft: '1rem',
                                    borderBottom: '1px solid black'
                                } },
                                React.createElement("tr", null,
                                    React.createElement("td", null,
                                        React.createElement("span", { style: { fontWeight: 600 } }, job.name))),
                                React.createElement("tr", null,
                                    React.createElement("td", null, job.new_revision.notes)))))); }),
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement("table", { style: {
                                    width: '100%',
                                    marginLeft: '1rem',
                                    borderBottom: '1px solid black'
                                } },
                                React.createElement("tr", null,
                                    React.createElement("td", null,
                                        React.createElement("span", { style: { fontWeight: 600, fontSize: '13px' } }, (0, translation_1.getLocalization)('diaryEntriesView/printEntries/ongoingJobs'))))))),
                    ongoingJobs.map(function (job) { return (React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement("table", { style: {
                                    width: '100%',
                                    marginLeft: '1rem',
                                    borderBottom: '1px solid black'
                                } },
                                React.createElement("tr", null,
                                    React.createElement("td", null,
                                        React.createElement("span", { style: { fontWeight: 600 } }, job.name))),
                                React.createElement("tr", null,
                                    React.createElement("td", null, job.new_revision.notes)))))); }),
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement("table", { style: {
                                    width: '100%',
                                    marginLeft: '1rem',
                                    borderBottom: '1px solid black'
                                } },
                                React.createElement("tr", null,
                                    React.createElement("td", null,
                                        React.createElement("span", { style: { fontWeight: 600, fontSize: '13px' } }, (0, translation_1.getLocalization)('diaryEntriesView/printEntries/readyJobs'))))))),
                    readyJobs.map(function (job) { return (React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement("table", { style: {
                                    width: '100%',
                                    marginLeft: '1rem',
                                    borderBottom: '1px solid black'
                                } },
                                React.createElement("tr", null,
                                    React.createElement("td", null,
                                        React.createElement("span", { style: { fontWeight: 600 } }, job.name))),
                                React.createElement("tr", null,
                                    React.createElement("td", null, job.new_revision.notes)))))); }),
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement("table", { style: {
                                    width: '100%',
                                    marginLeft: '1rem',
                                    borderBottom: '1px solid black'
                                } },
                                React.createElement("tr", null,
                                    React.createElement("td", null,
                                        React.createElement("span", { style: { fontWeight: 600, fontSize: '13px' } }, (0, translation_1.getLocalization)('diaryEntriesView/printEntries/onholdJobs'))))))),
                    onholdJobs.map(function (job) { return (React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement("table", { style: {
                                    width: '100%',
                                    marginLeft: '1rem'
                                    // borderBottom: '1px solid black'
                                } },
                                React.createElement("tr", null,
                                    React.createElement("td", null,
                                        React.createElement("span", { style: { fontWeight: 600 } }, job.name))),
                                React.createElement("tr", null,
                                    React.createElement("td", null, job.new_revision.notes)))))); })),
                React.createElement("table", { style: {
                        width: '100%',
                        textAlign: 'left',
                        borderBottom: '2px solid black'
                    }, id: "printentries-table-plan-info-".concat(entry.entry_uuid) },
                    React.createElement("tr", null,
                        React.createElement("th", { style: { fontSize: '15px', fontWeight: 600 } },
                            (0, translation_1.getLocalization)('diaryEntriesView/printEntries/planInfo'),
                            ":")),
                    React.createElement("tbody", null, entry.plan_info ? (React.createElement("tr", null,
                        React.createElement("td", null, entry.plan_info))) : (React.createElement("tr", null,
                        React.createElement("td", null, "-"))))),
                React.createElement("table", { style: {
                        width: '100%',
                        textAlign: 'left',
                        borderBottom: '2px solid black'
                    }, id: "printentries-table-review-info-".concat(entry.entry_uuid) },
                    React.createElement("tr", null,
                        React.createElement("th", { style: { fontSize: '15px', fontWeight: 600 } },
                            (0, translation_1.getLocalization)('diaryEntriesView/printEntries/reviewInfo'),
                            ":")),
                    React.createElement("tbody", null, entry.review_info ? (React.createElement("tr", null,
                        React.createElement("td", null, entry.review_info))) : (React.createElement("tr", null)))),
                React.createElement("table", { id: "printentries-table-small-critical-changes-".concat(entry.entry_uuid) },
                    React.createElement("tr", null,
                        React.createElement("th", { style: { fontSize: '15px', fontWeight: 600 } },
                            (0, translation_1.getLocalization)('diaryEntriesView/printEntries/smallCriticalChanges'),
                            ":")),
                    React.createElement("tbody", null, entry.small_critical_changes ? (React.createElement("tr", null,
                        React.createElement("td", null, entry.small_critical_changes))) : (React.createElement("tr", null,
                        React.createElement("td", null, "-"))))),
                React.createElement("table", { style: {
                        width: '100%',
                        textAlign: 'left',
                        borderBottom: '2px solid black'
                    }, id: "printentries-table-change-offers-".concat(entry.entry_uuid) },
                    React.createElement("tr", null,
                        React.createElement("th", { style: { fontSize: '15px', fontWeight: 600 } },
                            (0, translation_1.getLocalization)('diaryEntriesView/printEntries/changeOffers'),
                            ":")),
                    React.createElement("tbody", null, entry.change_offers ? (React.createElement("tr", null,
                        React.createElement("td", null, entry.change_offers))) : (React.createElement("tr", null,
                        React.createElement("td", null, "-"))))),
                React.createElement("table", { id: "printentries-table-additional-time-".concat(entry.entry_uuid), style: {
                        width: '100%',
                        textAlign: 'left',
                        borderBottom: '2px solid black'
                    } },
                    React.createElement("tr", null,
                        React.createElement("th", { style: { fontSize: '15px', fontWeight: 600 } },
                            (0, translation_1.getLocalization)('diaryEntriesView/printEntries/additionalTime'),
                            ":")),
                    React.createElement("tbody", null, entry.additional_time ? (React.createElement("tr", null,
                        React.createElement("td", null, entry.additional_time))) : (React.createElement("tr", null,
                        React.createElement("td", null, "-")))),
                    React.createElement("tr", { style: { borderBottom: '2px solid black' } })),
                React.createElement("table", { id: "printentries-table-additional-notes-".concat(entry.entry_uuid) },
                    React.createElement("tr", null,
                        React.createElement("th", { style: { fontSize: '15px', fontWeight: 600 } },
                            (0, translation_1.getLocalization)('diaryEntriesView/printEntries/additionalNotes'),
                            ":")),
                    React.createElement("tbody", null, entry.additional_notes ? (React.createElement("tr", null,
                        React.createElement("td", null, entry.additional_notes))) : (React.createElement("tr", null,
                        React.createElement("td", null, "-")))),
                    React.createElement("tr", { style: { borderBottom: '2px solid black' } })),
                React.createElement("table", { id: "printentries-table-other-notes-".concat(entry.entry_uuid), style: {
                        width: '100%',
                        textAlign: 'left',
                        borderBottom: '2px solid black'
                    } },
                    React.createElement("tr", null,
                        React.createElement("th", { style: { fontSize: '15px', fontWeight: 600 } },
                            (0, translation_1.getLocalization)('diaryEntriesView/printEntries/otherNotes'),
                            ":")),
                    React.createElement("tbody", null, entry.other_notes ? (React.createElement("tr", null,
                        React.createElement("td", null, entry.other_notes))) : (React.createElement("tr", null,
                        React.createElement("td", null, "-")))),
                    React.createElement("tr", { style: { borderBottom: '2px solid black' } })),
                React.createElement("table", { id: "printentries-table-supervisor-notes-".concat(entry.entry_uuid), style: {
                        width: '100%',
                        textAlign: 'left',
                        borderBottom: '2px solid black'
                    } },
                    React.createElement("tr", null,
                        React.createElement("th", { style: { fontSize: '15px', fontWeight: 600 } },
                            (0, translation_1.getLocalization)('diaryEntriesView/printEntries/supervisorNotes'),
                            ":")),
                    React.createElement("tbody", null, entry.supervisor_notes ? (React.createElement("tr", null,
                        React.createElement("td", null, entry.supervisor_notes))) : (React.createElement("tr", null,
                        React.createElement("td", null, "-")))),
                    React.createElement("tr", { style: { borderBottom: '2px solid black' } })),
                React.createElement("table", { style: {
                        width: '100%',
                        textAlign: 'left',
                        borderBottom: '2px solid black'
                    }, id: "printentries-table-images-".concat(entry.entry_uuid) },
                    React.createElement("tr", null,
                        React.createElement("th", { style: { fontSize: '15px', fontWeight: 600 } },
                            (0, translation_1.getLocalization)('diaryEntriesView/printEntries/images'),
                            ":")),
                    React.createElement("tbody", null, entry.images && entry.images.length !== 0 ? (entry.images.map(function (entry) { return (React.createElement("tr", null,
                        React.createElement("td", null, entry.name))); })) : (React.createElement("tr", null,
                        React.createElement("td", null, "-")))),
                    React.createElement("tr", { style: { borderBottom: '2px solid black' } })),
                React.createElement("table", null,
                    React.createElement("tr", null,
                        React.createElement("th", { style: { fontSize: '15px', fontWeight: 600 } },
                            (0, translation_1.getLocalization)('diaryEntriesView/printEntries/attachments'),
                            ":")),
                    React.createElement("tbody", null, entry.attachments && entry.attachments.length !== 0 ? (entry.attachments.map(function (entry) {
                        if (entry.type === 'FOLDER' && entry.name === 'images') {
                            return undefined;
                        }
                        else {
                            return (React.createElement("tr", null,
                                React.createElement("td", null, entry.name)));
                        }
                    })) : (React.createElement("td", null,
                        React.createElement("tr", null, "-")))),
                    React.createElement("tr", { style: { borderBottom: '2px solid black' } })),
                React.createElement("table", { style: {
                        width: '100%',
                        textAlign: 'left',
                        borderBottom: '2px solid black'
                    }, id: "printentries-table-signatures-".concat(entry.entry_uuid) },
                    React.createElement("tr", null,
                        React.createElement("th", { style: { fontSize: '15px', fontWeight: 600 } },
                            (0, translation_1.getLocalization)('diaryEntriesView/printEntries/signatures'),
                            ":")),
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            (0, translation_1.getLocalization)('diaryEntriesView/printEntries/masterSignature'),
                            ": ",
                            entry.master_signature ? entry.master_signature : '-')),
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            (0, translation_1.getLocalization)('diaryEntriesView/printEntries/supervisorSignature'),
                            ":",
                            ' ',
                            entry.supervisor_signature ? entry.supervisor_signature : '-'))),
                React.createElement("table", { style: {
                        width: '100%',
                        textAlign: 'left',
                        borderBottom: '2px solid black'
                    }, id: "printentries-table-comments-".concat(entry.entry_uuid) },
                    React.createElement("tr", null,
                        React.createElement("th", null, (0, translation_1.getLocalization)('diaryEntriesView/printEntries/comments'))),
                    entry.comments && entry.comments.length !== 0 ? (entry.comments.map(function (entry) { return (React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", null,
                                moment(entry.created_at).format('L HH.mm'),
                                " (",
                                entry.user_fullname,
                                ")")),
                        React.createElement("tr", null, entry.comment),
                        React.createElement("tr", { style: { background: 'black', height: '1px' } },
                            React.createElement("td", null)))); })) : (React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", null, "-")))))));
        });
        setPdfContent(pdf);
        setPdfFileName(pdfTempFileName);
    }, [props.printEntries.list]);
    return (React.createElement(sok_ui_1.Modal, { isOpen: props.show, className: 'diary-entries-modal-print-entries' },
        React.createElement(sok_ui_1.Header, { onClose: function () {
                props.clearDiaryEntriesToPrint();
                props.closeModal();
            } }, (0, translation_1.getLocalization)('diaryEntriesView/printEntries/header')),
        React.createElement("form", null,
            React.createElement("div", { className: "modal-content-container" }, props.printEntries.status === 'STANDBY' ? (React.createElement("div", { className: "modal-initial-content" },
                React.createElement("h4", null, (0, translation_1.getLocalization)('diaryEntriesView/printEntries/fileformat')),
                React.createElement("div", { className: "inputs-container" },
                    React.createElement(sok_ui_1.Input, { type: "radio", name: "pdfradio", checked: true, label: 'PDF', defaultChecked: true })),
                React.createElement("h4", null, (0, translation_1.getLocalization)('diaryEntriesView/printEntries/timeframe')),
                React.createElement("div", { className: "dates-container" },
                    React.createElement("div", { className: "start-date-container" },
                        React.createElement(DatePicker_1.DatePicker, { selected: moment(props.startDate), minDate: moment(getMinMaxEntries().firstEntry), maxDate: moment(), onChange: function (e) {
                                return props.setStartDate(moment(e).toDate());
                            } })),
                    React.createElement("div", { className: "end-date-container" },
                        React.createElement(DatePicker_1.DatePicker, { selected: moment(props.endDate), minDate: moment(props.startDate), maxDate: moment(), onChange: function (e) {
                                return props.setEndDate(moment(e).toDate());
                            } }))))) : (React.createElement("div", { className: "spinner-container" },
                React.createElement(sok_ui_1.RequestSpinner, { isLoading: props.printEntries.status === 'FETCHING', success: props.printEntries.status === 'FETCHED' }),
                React.createElement("p", null, props.printEntries.status === 'FETCHING'
                    ? (0, translation_1.getLocalization)('diaryEntriesView/printEntries/generatingreport')
                    : (0, translation_1.getLocalization)('diaryEntriesView/printEntries/reportReady')),
                props.printEntries.status === 'FETCHED' && (React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('diaryEntriesView/printEntries/download'), color: 'blue', onClick: startDownload }))))),
            React.createElement(sok_ui_1.Footer, null,
                React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('diaryEntriesView/printEntries/close'), color: 'dark-gray', disabled: props.printEntries.status === 'FETCHING', onClick: function () {
                        props.clearDiaryEntriesToPrint();
                        props.closeModal();
                    } }),
                props.printEntries.status !== 'FETCHED' && (React.createElement(sok_ui_1.Button, { text: (0, translation_1.getLocalization)('diaryEntriesView/printEntries/create'), disabled: props.printEntries.status === 'FETCHING', color: 'base-green', onClick: fetchEntriesToPrint })))),
        React.createElement("div", { ref: pdfRef, id: "pdf", style: { display: 'none' } },
            React.createElement("div", { id: "pdf-contents" },
                React.createElement("table", { style: {
                        width: '100%',
                        textAlign: 'left',
                        borderBottom: '2px solid black',
                        fontFamily: '"Roboto", sans-serif'
                    }, id: "printentries-table-main-header" },
                    React.createElement("tr", null,
                        React.createElement("td", { style: { fontSize: '1rem', fontWeight: 600 } }, (0, translation_1.getLocalization)('diaryEntriesView/printEntries/worksiteDiary')))),
                pdfContent && pdfContent))));
});
